import React, { useState } from 'react';
import editIcon from '@sg/assests/svg/edit-icon.svg';
import editIconHighlight from '@sg/assests/svg/edit-icon-highlight.svg';
import './index.scss';
import { Bubble } from 'tea-component';

interface EditButtonProps {
  onClick: (e?: React.MouseEvent) => void;
  className?: string;
  title?: string;
  disabled?: boolean;
  useBubble?: boolean; // 是否使用 Bubble 弹窗，默认 false 使用原生 alt 提示
}

const EditButton: React.FC<EditButtonProps> = ({
  onClick,
  className = '',
  title = 'Edit',
  disabled = false,
  useBubble = true
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    if (disabled) return;
    e?.stopPropagation();
    onClick(e);
  };

  const imgElement = (
    <img 
      src={isHovered ? editIconHighlight : editIcon} 
      alt={useBubble ? undefined : title}
      title={useBubble ? undefined : title}
      className={`dbs-edit-button ${className} ${disabled ? 'dbs-edit-button-disabled' : ''}`}
      onClick={handleClick}
      onMouseEnter={() => !disabled && setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    />
  );

  // 如果使用 Bubble，则包裹 Bubble 组件
  if (useBubble) {
    return (
      <Bubble content={title} trigger="hover">
        {imgElement}
      </Bubble>
    );
  }

  // 默认返回原生提示
  return imgElement;
};

export default EditButton;

